module.exports = __webpack_public_path__ + "img/parceiro5.e131b2c8.png";